<template>
  <MarketWrapper
    :initial-fields="initialFields"
    title-hero="Battery & Gigafactory Sustainability"
    :image-hero="SUSTAINABILITY_HERO_IMAGE"
    :brochure-file-info="brochureFileInfo"
    :title-page="titlePage"
    :icon="icon"
    :tabs="tabs"
    has-bookable-demo
    @active-tab-changed="changeActiveTab"
  >
    <div class="relative pt-6">
      <NuxtPage
        :market="market"
        :initial-fields="initialFields"
        :subscription="subscription"
      />
    </div>
  </MarketWrapper>
</template>

<script setup lang="ts">
import useAuthentication from '~/composables/useAuthentication'
import {
  ESG,
  LITHIUM_ION_BATTERIES,
  SUBSCRIPTION_ESG_LITHIUM_ION_BATTERIES,
} from '~/constants/services/constants'

import {
  BROCHURE_FILE_INFO,
  SUSTAINABILITY_HERO_IMAGE,
} from '~/src/constants/sustainability'
import MarketWrapper from '~/components/shared/services/MarketWrapper.vue'
import type { TTab } from '~/src/types/ui'

const market = LITHIUM_ION_BATTERIES
const initialFields = [market.slug, ESG.checkbox]
const subscription = SUBSCRIPTION_ESG_LITHIUM_ION_BATTERIES

const { $config } = useNuxtApp()
const BROCHURE_ENV_KEY = BROCHURE_FILE_INFO[market.slug].EnvKey

const brochureFileInfo = {
  ...BROCHURE_FILE_INFO[market.slug],
  ID: $config.public[BROCHURE_ENV_KEY],
}

const router = useRouter()
const { isAuthenticated } = useAuthentication()

const titlePage = `${market.name} ${ESG.name}`
const icon = market.iconColor
const baseUrl = '/battery-gigafactory/sustainability'

const tabs = computed<TTab[]>(() =>
  [
    {
      name: 'Overview',
      slug: 'overview',
      url: `${baseUrl}/overview`,
      hide: isAuthenticated(),
    },
    {
      name: 'Battery Emissions Analyser',
      slug: 'battery-emissions-analyser',
      url: `${baseUrl}/battery-emissions-analyser`,
      hide: false,
    },
  ].filter((tab) => !tab.hide),
)

const changeActiveTab = (tab: string) => {
  router.push(tab)
}
</script>
